<template>
  <div class="info" id="performanceInfo">
    <!-- <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px;"
          type="text"
          icon="el-icon-back"
          @click="$router.go(-1)"
        >
          返回
        </el-button>
      </el-col>
    </el-row> -->

    <div class="main1">
      <headerflow v-if="pageInfo.id" :info="pageInfo" />
    </div>
    <div class="main2" style="margin-top: 10px; background: #fff">
      <div class="header_flow" style="padding: 22px; height: auto">
        <div class="alertTpis">
          <i class="el-icon-info" size="16"></i
          >该绩效考核表适用于对各部门的月度绩效考核，主要包括关键业绩指标、GS目标、工作能力与态度指标、加减分项四个部分，考核权重根据具体岗位略有调整，累计为100%。其中，GS目标为重要工作目标，关键结果为考核标准。每一项自评、他评
          均为10分制，加分项、扣分项在总分基础上直接加减即可，为5分制。最小打分分差为0.5。
        </div>
        <tableStyle
          v-if="pageInfo.target_1"
          :info="pageInfo.target_1"
          :status="pageInfo.status"
          :enableModule="pageInfo.enable_module"
          :k="'target_1'"
          @addItem="addItem('target_1')"
          @deleteItem="deleteItem"
          @updateValue="getUpdateValue"
          style="margin-top: 30px"
        ></tableStyle>
        <tableStyle
          v-if="pageInfo.target_2"
          :info="pageInfo.target_2"
          :status="pageInfo.status"
          :enableModule="pageInfo.enable_module"
          :k="'target_2'"
          @addItem="addItem('target_2')"
          @deleteItem="deleteItem"
          @updateValue="getUpdateValue"
          style="margin-top: 30px"
        ></tableStyle>

        <tableStyle
          v-if="pageInfo.target_3"
          :info="pageInfo.target_3"
          :status="pageInfo.status"
          :enableModule="pageInfo.enable_module"
          :k="'target_3'"
          @addItem="addItem('target_3')"
          @deleteItem="deleteItem"
          @updateValue="getUpdateValue"
          style="margin-top: 30px"
        ></tableStyle>

        <other
          v-if="pageInfo.target_4"
          :info="pageInfo.target_4"
          :status="pageInfo.status"
          :enableModule="pageInfo.enable_module"
          :k="'target_4'"
          style="margin-top: 30px"
        ></other>
        <botTable style="margin-top: 30px" :CommentList="CommentList"></botTable>
        <jxInfo style="margin-top: 30px"></jxInfo>
      </div>
    </div>
    <el-container id="footers">
      <el-footer class="footer">
        <template v-if="pageInfo.status != 2 && pageInfo.enable_module != ''">
          <div class="btn" @click="draft">暂存</div>
          <div class="btn" @click="submit">提交考核</div>
        </template>
        <div class="total">考核汇总得分：{{ total }}</div>
        <div class="evaluate" v-if="pageInfo.enable_module != '' && pageInfo.enable_module != 'self_rating'" @click="addevaluateHandel">增加评语</div>
      </el-footer>
    </el-container>

    <div class="zzc" v-show="confirmDailog" @click.self="confirmDailog = false">
      <div class="pubDailog">
        <div class="content">
          <img src="@/assets/icon3.png" />确认提交考核吗
          <span>提交后不允许更改</span>
        </div>
        <div class="btnBox">
          <div class="btn cancel" @click.self="confirmDailog = false">取消</div>
          <div class="btn confirm" @click.self="saveData(2)">确定</div>
        </div>
      </div>
    </div>
    <div class="dailogZzc" v-show="textDailog">
      <div class="dailog">
        <div class="inputBox">
          <el-input
            type="textarea"
            maxlength="500"
            placeholder="请输入"
            show-word-limit
            v-model="text"
            resize="none"
            class="abc"
          >
          </el-input>
        </div>
        <div class="btnBox">
          <div class="btn cancel" @click="cancelUpdate">取消</div>
          <div class="btn confirm" @click="confirmUpdate">确认</div>
        </div>
        <!-- autosize -->
        <!-- :readonly="!status == 1 || !!item.target.disable" -->
      </div>
    </div>
    <div class="dailogZzc" v-show="textDailog2">
      <div class="dailog">
        <div class="inputBox">
          <el-input
            type="textarea"
            maxlength="500"
            placeholder="请输入"
            show-word-limit
            v-model="text2"
            resize="none"
          >
          </el-input>
        </div>
        <div class="btnBox">
          <div class="btn cancel" @click="cancelUpdate2">取消</div>
          <div class="btn confirm" @click="confirmUpdate2">确认</div>
        </div>
        <!-- autosize -->
        <!-- :readonly="!status == 1 || !!item.target.disable" -->
      </div>
    </div>
  </div>
</template>

<script>
import headerflow from "./components/header_flow.vue";
import tableStyle from "./components/tableStyle.vue";
import other from "./components/else.vue";
import botTable from "./components/botTable.vue";
import jxInfo from "./components/jxInfo.vue";
import { getDetail, saveData } from "@/api/promotion";
import {getCommentList,saveCommentData } from "@/api/performance";
import { collect } from "collect.js";
export default {
  data() {
    return {
      loading: true,
      id: this.$route.query.id,
      pageInfo: {},
      confirmDailog: false,
      text: "",
      textDailog: false,
      textDailog2:false,
      text2: "",
      updateInfo: {},
      CommentList:[],
      autoDjs:null,
    };
  },
  components: {
    headerflow,
    tableStyle,
    botTable,
    other,
    jxInfo,
  },
  created() {
    this.loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.getPageInfo();
    this.getgetCommentList()
  },
  mounted() {
    // console.log(this.$route.params.param);
    
    // this.autoSave()//自动保存
  },
  watch:{
    textDailog(newVal){
      if(!newVal)return
      this.$nextTick(() => {
        var a = document.getElementsByClassName("abc")[0].getElementsByTagName("textarea")[0];
        a.focus()
      })
    }
  },
  computed: {
    // 当前角色的总分数
    total() {
      if (JSON.stringify(this.pageInfo) == "{}") return 0;
      if (this.pageInfo.enable_module == "") return "-";
      let collection1 = collect(this.pageInfo.target_1);
      let total1 = collection1.sum((product) =>
        Number(product[this.pageInfo.enable_module].value)
      );

      let collection2 = collect(this.pageInfo.target_2);
      let total2 = collection2.sum((product) =>
        Number(product[this.pageInfo.enable_module].value)
      );

      let collection3 = collect(this.pageInfo.target_3);
      let total3 = collection3.sum((product) =>
        Number(product[this.pageInfo.enable_module].value)
      );

      let collection4 = collect(this.pageInfo.target_4);
      let total4 = collection4.sum((product) =>
        Number(product[this.pageInfo.enable_module].value)
      );
      return total1 + total2 + total3 + total4 || 0;
    },
  },
  methods: {
    autoSave(){
      let that = this
      that.autoDjs = setInterval(() => {
        that.draft(3)
      },1000*10)
    },
    addevaluateHandel(){
      this.textDailog2 = true;
    },
    getUpdateValue(opt) {
      this.textDailog = true;
      this.text = this.pageInfo[opt.target][opt.index][opt.key].value;
      this.updateInfo = opt;
    },
    confirmUpdate() {
      let opt = this.updateInfo;
      this.pageInfo[opt.target][opt.index][opt.key].value = this.text;
      this.cancelUpdate();
    },
    confirmUpdate2(){
      let that = this;
      saveCommentData({
        performance_id:that.id,
        level: that.pageInfo.enable_module,
        content:that.text2
      }).then((res)=>{
        console.log(res);
        if(res.code == 1){
          that.$message.success("评价成功");
          that.textDailog2 = false;
          that.getgetCommentList()
        }else{
          that.$message.error(res.message);
        }
      })
    },
    cancelUpdate() {
      this.textDailog = false;
      this.text = "";
      this.updateInfo = {};
    },
    cancelUpdate2(){
      this.textDailog2 = false;
      this.text2 = "";
    },
    getPageInfo() {
      let that = this;
      getDetail({ id: that.id }).then((response) => {
        that.pageInfo = response.data;
        console.log("that.loading", that.loading);
        that.loading.close();
        if([0,1].includes(that.pageInfo.status) && that.pageInfo.enable_module == 'self_rating'){
          console.log("11111",that.pageInfo.status);
          that.autoSave()
        }
      });
    },
    getgetCommentList(){
      let that = this
      getCommentList({performance_id: that.id }).then((res)=>{
        if(res.code == 1){
          this.CommentList = res.data
        }
      })
    },
    // 添加表格行
    addItem(key){
      let result = this.pageInfo[key].slice(this.pageInfo[key].length-1,this.pageInfo[key].length)
      let result2 = JSON.parse(JSON.stringify(result));// 深拷贝
      result2[0].id.value++
      result2[0].weight.value = 0.5
      result2[0].summarize.value = ''
      result2[0].self_rating.value = 0
      result2[0].result.value = ''
      result2[0].target.value = ''
      // result2[0].second_rating.value = 0
      // result2[0].third_rating.value = 0
      console.log(result2,key);
      this.pageInfo[key] = [...this.pageInfo[key],...result2]
    },
    deleteItem(opt) {
      this.pageInfo[opt.key].splice(opt.index, 1);
      this.pageInfo[opt.key].map((element, index) => {
        element.id.value = index * 1 + 1;
        console.log(index, element);
      });
    },
    submit() {
      let newArr = [
        ...this.pageInfo.target_1,
        ...this.pageInfo.target_2,
        ...this.pageInfo.target_3,
      ];
      let err = false;
      // 先重置
      newArr.forEach((item) => {
        for (let chil in item) {
          item[chil].warning = 0;
        }
      });
      newArr.forEach((item) => {
        for (let chil in item) {
          console.log(item, item[chil].required == 1, !item[chil].value);
          if (item[chil].required == 1 && !item[chil].value) {
            item[chil].warning = 1;
            err = true;
          }
        }
      });
      if (err) {
        this.$message.error("页面中有未填项，请完整填写表格~");
        return;
      }

      let collection1 = collect(this.pageInfo.target_1);
      let target_1WeightTotal = collection1.sum((product) =>
        Number(product.weight.value)
      );
      if (Number(target_1WeightTotal) < 50) {
        this.$message.error("关键性业绩考核指标权重未达50%");
        return;
      }
      if (Number(target_1WeightTotal) > 50) {
        this.$message.error("关键性业绩考核指标权重超出50%");
        return;
      }
      let collection2 = collect(this.pageInfo.target_2);
      let target_2WeightTotal = collection2.sum((product) =>
        Number(product.weight.value)
      );
      if (Number(target_2WeightTotal) < 30) {
        this.$message.error("GS工作目标权重未达30%");
        return;
      }
      if (Number(target_2WeightTotal) > 30) {
        this.$message.error("GS工作目标权重超出30%");
        return;
      }
      let collection3 = collect(this.pageInfo.target_3);
      let target_3WeightTotal = collection3.sum((product) =>
        Number(product.weight.value)
      );
      if (Number(target_3WeightTotal) < 20) {
        this.$message.error("工作能力与态度指标权重未达20%");
        return;
      }
      if (Number(target_3WeightTotal) > 20) {
        this.$message.error("工作能力与态度指标权重超出20%");
        return;
      }
      this.confirmDailog = true;
      // this.saveData(2)
    },
    draft(key) {
      let newArr = [
        ...this.pageInfo.target_1,
        ...this.pageInfo.target_2,
        ...this.pageInfo.target_3,
      ];
      // 先重置
      newArr.forEach((item) => {
        for (let chil in item) {
          item[chil].warning = 0;
        }
      });
      if(key == 3){
        this.saveData(3);
        return
      }
      this.saveData(1);
    },
    saveData(status) {
      let that = this;
      that.confirmDailog = false;
      let loading
      if(status != 3){
        loading = that.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
      }
      let option = {
        id: that.id,
        status: status == 3 ? 1 : status, //1-暂存草稿，2-提交绩效,3-自动保存（没有保存成功提示）
        target_1: that.pageInfo.target_1,
        target_2: that.pageInfo.target_2,
        target_3: that.pageInfo.target_3,
        target_4: that.pageInfo.target_4, 
      };
      saveData(option).then((response) => {
        console.log(response);
        if(status != 3){
          loading.close();
        }
        if(status == 3) return
        if (response.code == 1) {
          
          clearInterval(that.autoDjs)
          that.$message({
            message: `${response.message}`,
            type: "success",
          });
          location.reload()
          that.$router.go(-1);
          if (status == 2) {
            that.getPageInfo();
            return;
          }
        }
      });
    },
  },
  beforeDestroy(){
    clearInterval(this.autoDjs)
  }
};
</script>
<style scoped>
body,
html {
  width: 100%;
  height: 100%;
  /* box-sizing: border-box; */
}

body {
  margin: 0 !important;
}
.main2 {
  margin: 0 16px 0;
  border-radius: 12px;
  margin-bottom: 90px;
}
.info {
  width: 100%;
  /* height: 100vh; */
  /* height: 1112px; */
  padding: 16px 0;
  position: relative;
  background: #f0f4fb;
  box-sizing: border-box;
  /* overflow-y: hidden; */
  overflow-x: hidden;
}
.info .main1 {
  width: 100%;
  /* background-color: #fff; */
  /* height: 100%; */
  padding: 0 16px 0;
  /* margin-top: 17px; */
  box-sizing: border-box;
}
#performanceInfo .alertTpis {
  background: #f7f9fc;
  border-radius: 12px;
  padding: 22px;
  font-size: 16px;
  color: #919399;
  line-height: 26px;
}
#performanceInfo .alertTpis .el-icon-info {
  margin-right: 0.25rem /* 5/20 */;
}
#footers {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99;
}
.evaluate {
  width: 100px;
  height: 36px;
  border: 1px solid #f77e00;
  border-radius: 18px;
  line-height: 40px;
  text-align: center;
  color: #f77e00;
  cursor: pointer;
}
</style>